import PageHeader from "../components/PageHeader";

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <PageHeader eyebrow="Legal" title="Privacy Policy" subtitle="Last updated: November 2025" />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 prose-blog">
        <p>CashPark Inc ("CashPark", "we", "us") respects your privacy. This Privacy Policy explains what personal data we collect, how we use it, and the rights you have over it.</p>
        <h2>1. Information we collect</h2>
        <p>We collect information you provide directly (such as your name, address, government-issued ID, date of birth, phone number, email, and banking details), information collected automatically (such as device data, IP address, and usage analytics), and information from third parties (such as identity verification providers and payment processors).</p>
        <h2>2. How we use your information</h2>
        <ul>
          <li>To verify your identity (KYC) and screen against sanctions and watchlists (AML)</li>
          <li>To process and settle your transfers</li>
          <li>To prevent fraud and meet legal obligations under FINTRAC and CBN regulations</li>
          <li>To communicate with you about your account and provide customer support</li>
          <li>To improve our services and detect operational issues</li>
        </ul>
        <h2>3. Sharing your information</h2>
        <p>We share your data with payout partners, banks, identity verification providers, regulators, and law enforcement when legally required. We do not sell your personal data.</p>
        <h2>4. Data retention</h2>
        <p>We retain customer data for at least five (5) years after the end of your relationship with us, as required by anti-money laundering regulations.</p>
        <h2>5. Your rights</h2>
        <p>Subject to applicable law, you may request access to, correction of, or deletion of your personal data, and you may object to certain processing. Email <a href="mailto:contact@mycashpark.com">contact@mycashpark.com</a> to exercise these rights.</p>
        <h2>6. Security</h2>
        <p>We use industry-standard technical and organizational safeguards including encryption in transit and at rest, principle-of-least-privilege access, and routine security testing.</p>
        <h2>7. Changes</h2>
        <p>We may update this Privacy Policy from time to time. Material changes will be notified by email or via our website.</p>
        <h2>8. Contact us</h2>
        <p>Questions? Email <a href="mailto:contact@mycashpark.com">contact@mycashpark.com</a> or call +1 403 8272668.</p>
      </section>
    </div>
  );
}
